<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<h2 class="h2p"><a id="page_3"></a>Part One</h2>
<h2 class="h2a"><img alt="image" src="images/common.jpg"/></h2>
</div>
<p class="pagebreak"> </p>
<p class="center-para"><a id="page_4"></a><em>The mountain she saw before her that measured<br/> the distance she had to climb to gain her daddy’s favor<br/> back from being; ‘nothing but an idiot’,<br/> was too high for such a little girl<br/> who only wanted to hear the words;<br/> “Kieran, I love you and I’m proud of you.”</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?d3b0c0e4